'use strict';

function StorageUtil (store) {
  var namespacedStore = store.getNamespacedStore('skydash');
  return namespacedStore;
}

StorageUtil.$inject = ['store'];
module.exports = StorageUtil;


// WEBPACK FOOTER //
// ./src/common/utils/StorageUtil.js